import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/work-schedule/_layout/settings/')({
  component: () => <ComingSoonCover />
});